(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-category-slider"] && !window.DesignMode) return;
  try {
    
  const NWCategorySlider = new Swiper('.NWCategorySlider', {
    slidesPerView: 2,
    spaceBetween: 0,
    centeredSlides: true,
    speed: 800,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-featured-blogs"] && !window.DesignMode) return;
  try {
    
  const NWFeaturedBlogsSlider = new Swiper('.NWFeaturedBlogsSlider', {
    slidesPerView: 3,
    spaceBetween: 34,
    speed: 800,
    loop: false,
    navigation: {
      nextEl: '.NW-Featured-Blogs__slider-arrow .swiper-button-next',
      prevEl: '.NW-Featured-Blogs__slider-arrow .swiper-button-prev',
    },
    breakpoints: {
      1: {
        slidesPerView: 1.5,
        spaceBetween: 16,
      },
      750: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 34,
      },
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-how-it-works"] && !window.DesignMode) return;
  try {
    
  const NWHowItWorks = new Swiper('.NWHowItWorks', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    pagination: {
      el: ".NWHowItWorks .swiper-pagination",
      type: "fraction",
    },
    navigation: {
      nextEl: '.NWHowItWorks .swiper-button-next',
      prevEl: '.NWHowItWorks .swiper-button-prev',
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-our-stylists"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tab-nav a");
  const tabContents = document.querySelectorAll(".tab-content");

  // Attach click event listeners to all tabs
  tabs.forEach((tab) => {
    tab.addEventListener("click", function (event) {
      event.preventDefault();

      // Remove the active class from all tabs and tab content
      tabs.forEach((t) => t.classList.remove("active"));
      tabContents.forEach((content) => content.classList.remove("active"));

      // Add the active class to the clicked tab
      this.classList.add("active");

      // Find the corresponding tab content by matching the href with the id
      const targetId = this.getAttribute("href").replace("#", "");
      const targetContent = document.getElementById(targetId);

      if (targetContent) {
        targetContent.classList.add("active");
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-press"] && !window.DesignMode) return;
  try {
    
  const NWPressSlider = new Swiper('.NWPressSlider', {
    slidesPerView: 1,
    spaceBetween: 20,
    speed: 800,
    loop: false,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-review-slider"] && !window.DesignMode) return;
  try {
    
  const NWReviewSlider = new Swiper(".NWReviewSlider", {
      grabCursor: true,
      effect: "creative",
      speed: 800,
      navigation: {
        nextEl: ".NWReviewSlider .swiper-button-next",
        prevEl: ".NWReviewSlider .swiper-button-prev",
      },
      creativeEffect: {
        prev: {
          shadow: true,
          translate: ["0%", 0, -1],
        },
        next: {
          translate: ["100%", 0, 0],
        },
      },
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-what-you-get"] && !window.DesignMode) return;
  try {
    
const NWWhatYouGetSlider = new Swiper('.NWWhatYouGetSlider', {
  slidesPerView: 1,
  spaceBetween: 20,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
});

  } catch(e) { console.error(e); }
})();
})();
